import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@fontsource/barlow";
import "@fontsource/barlow-semi-condensed";
import "@fontsource/source-sans-pro";
import reportWebVitals from "./reportWebVitals";
import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#041E42",
      light: "#EAF1F4",
      dark: "#0E183F",
      contrastText: "#fff",
    },
    secondary: {
      main: "#F7F3ED",
      light: "#D9D9D6",
      dark: "#63666A",
    },
    error: {
      main: "#E4002B",
      light: "#8A1538",
      dark: "#76232F",
    },
    info: {
      main: "#003880",
      light: "#5b6b74",
      dark: "#1B3962",
    },
    warning: {
      main: "#FF8200",
      light: "#FF8200",
      dark: "#CF4520",
    },
    success: {
      main: "#009444",
      light: "#4caf50",
      dark: "#1b5e20",
    },
  },
  typography: {
    fontFamily: ["Barlow", "Barlow Semi Condensed", "Source Sans Pro"].join(
      ","
    ),
  },
  spacing: 4,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
